module.exports = __webpack_public_path__ + "img/compilations.48504968.svg";